module.exports = __webpack_public_path__ + "static/media/partners--quotation.005f2ea9.png";